import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e989d13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 사업자유형을 선택해주세요. ")
const _hoisted_3 = { class: "icon-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "개인", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("사업자 ")
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "icon-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "법인", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("사업자 ")
const _hoisted_10 = ["src"]

import { onBeforeMount, ref } from 'vue'
import router from '@/router'

import Text from '@/components/common/TextComponent.vue'
import CompanyIcon from '@/styles/icon/CompanyIcon.vue'
import CompanyIndividualIcon from '@/styles/icon/CompanyIndividualIcon.vue'
import { getImageUrl } from '@/utils/getImageUrl'
import { OvertaxStorage } from '@/utils/overtax'
import  abTestController, { TestKey } from '@/utils/abTestController'
import { isFacebook, isInstagram, isAndroid } from '@/utils/navigator'


export default /*#__PURE__*/_defineComponent({
  name: 'Content',
  setup(__props) {

const isTargetB = ref(false)
const isProd = process.env.NODE_ENV === 'production'

const isTargetBrowser = () => {
  return isFacebook() || isInstagram()
}

const setAmplitudeParams = (params: URLSearchParams) => {
  if (!window.amplitude || !window.amplitude.getDeviceId || !window.amplitude.getSessionId) {
    return
  }
  const ampDeviceId = window.amplitude.getDeviceId() || ''
  const ampSessionId = window.amplitude.getSessionId() || ''
  params.append('ampDeviceId', ampDeviceId)
  params.append('ampSessionId', ampSessionId)
}

const escapeInAppBrowser = (targetUrl: string) => {
  const url = targetUrl.replace('https://', '')
  window.setTimeout(() => {
    window.open(targetUrl, '_blank')
  }, 1000)
  window.location.replace(`intent://${url}#Intent;package=com.android.chrome;scheme=https;end;`)
}

const loginIndividualWithKakao = () => {
  const params = new URLSearchParams(document.location.search);
  params.delete('code')
  params.append('target', 'landing')
  setAmplitudeParams(params)
  const targetObj: { [key: string]: string } = {}
  for (const [key, value] of params.entries()) {
    targetObj[key] = value
  }

  if (isTargetB.value && isTargetBrowser() && isAndroid()) {
    const prodUrl= 'https://app.sole.overtax.co.kr/'
    const stagUrl= 'https://sole-app.stag.overtax.co.kr/'

    const targetUrl = isProd ? prodUrl : stagUrl
    params.delete('target')
    const targetUrlWithParams = `${targetUrl}login?${params.toString()}`
    escapeInAppBrowser(targetUrlWithParams)
  } else {
    router.push({ name: 'login', query: targetObj })
  }
}

const loginCorporateWithKakao = () => {
  const stagUrl = 'https://stag-app.overtax.co.kr/'
  const prodUrl = 'https://app.overtax.co.kr/'

  const targetUrl = isProd ? prodUrl : stagUrl
  const params = new URLSearchParams(document.location.search);
  const sales_id = OvertaxStorage.get('sales_id')
  if (sales_id) {
    params.append('sales_id', sales_id)
    OvertaxStorage.init('sales_id')
  }
  params.delete('code')
  params.append('target_from', 'overtax')
  setAmplitudeParams(params)
  const targetUrlWithParams = `${targetUrl}sign-in?${params.toString()}`

  if (isTargetB.value && isTargetBrowser() && isAndroid()) {
    escapeInAppBrowser(targetUrlWithParams)
  } else {
    location.href = targetUrlWithParams
  }
}

onBeforeMount(async() => {
  await abTestController.init()
  isTargetB.value = abTestController.checkGroup(TestKey['2505_meta_inapp'], 'B')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Text, {
      size: "20px",
      weight: "bold"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "box individual",
      onClick: loginIndividualWithKakao
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CompanyIndividualIcon)
      ]),
      _createVNode(Text, {
        weight: "bold",
        margin: "9px 0 24px 0"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createElementVNode("img", {
        role: "button",
        src: _unref(getImageUrl)('kakao/kakao_login.png'),
        alt: "카카오 로그인 버튼"
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: "box corporate",
      onClick: loginCorporateWithKakao
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CompanyIcon)
      ]),
      _createVNode(Text, {
        weight: "bold",
        margin: "9px 0 24px 0"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      _createElementVNode("img", {
        role: "button",
        src: _unref(getImageUrl)('kakao/kakao_login.png'),
        alt: "카카오 로그인 버튼"
      }, null, 8, _hoisted_10)
    ])
  ]))
}
}

})